const initialState = {
  userDataFetch: false,
  userDataFetchSuccess: false,
  userDataFetchError: null,

  countries: [],
  roles: [],
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "USER_DATA_FETCH":
      return {
        ...state,
        userDataFetch: true,
        userDataFetchSuccess: false,
        userDataFetchError: null,
      };

    case "USER_DATA_FETCH_FULFILLED":
      return {
        ...state,
        userDataFetch: false,
        userDataFetchSuccess: true,

        countries: action.data.countries,
        roles: action.data.roles,
      };

    case "USER_DATA_FETCH_REJECTED":
      return {
        ...state,
        userDataFetch: false,
        userDataFetchSuccess: false,
        userDataFetchError: action.data,
      };

    default:
      return state;
  }
}
